export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-select-picker/index.js